import { useState, useEffect } from 'react'

// Import breakpoints from CSS variables
const BREAKPOINTS = {
  phone: 375,
  tablet: 768,
  desktop: 1024,
} as const

export const useBreakpoints = () => {
  const [screenSize, setScreenSize] = useState<'phone' | 'tablet' | 'desktop'>('desktop')

  useEffect(() => {
    const getScreenSize = () => {
      const width = window.innerWidth
      if (width < BREAKPOINTS.tablet) {
        return 'phone'
      } else if (width < BREAKPOINTS.desktop) {
        return 'tablet'
      }
      return 'desktop'
    }

    const handleResize = () => {
      setScreenSize(getScreenSize())
    }

    // Set initial value
    setScreenSize(getScreenSize())

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    screenSize,
    isPhone: screenSize === 'phone',
    isTablet: screenSize === 'tablet',
    isDesktop: screenSize === 'desktop',
    breakpoints: BREAKPOINTS,
  }
}